import React from "react";
import Favourites from "Pages/Favourites";


const Favtheme = () => {
  return (
    <React.Fragment>
        <Favourites/>
    </React.Fragment>
  );
};

export default Favtheme;
